module.exports = __webpack_public_path__ + "static/media/photo1.3a0be588.png";